export enum EventEnum {
    ORDER_RESTAURANT = 'orderRestaurant',
    COMMAND_RESTAURANT = 'commandRestaurant',
    NEW_VERSION = 'newVersion',
    STATUS_CLIENT_PRINTER = 'statusClientPrinter',
    NOTIFICATION = 'notification',
    /** Cambio en el catálogo local de productos (tekiwss, ProductCatalogMessage). */
    PRODUCTS_CHANGED = 'productsChanged',
}
